const binding = { modules: {}, dataActions: {} };

    (binding.modules['dlvry-split-hero-block'] = {
        c: () => require('partner/modules/dlvry-split-hero-block/dlvry-split-hero-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dlvry-split-hero-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dlvry-split-hero-block'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dlvry-split-hero-block|dlvry-split-hero-block'] = {
                c: () => require('partner/modules/dlvry-split-hero-block/dlvry-split-hero-block.view.tsx'),
                cn: '__local__-__local__-dlvry-split-hero-block'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };